'use client'
import { useState } from 'react'

import { Button } from '@/components/ui/button'
import { Menu, X, ChevronRight, ChevronLeft } from 'lucide-react'
import { cn } from '@/utilities/ui'
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from '@/components/ui/sheet'

export function MobileMenu({ navItems }: { navItems: any }) {
  const [isOpen, setIsOpen] = useState(false)
  const [activeSubmenu, setActiveSubmenu] = useState<any | null>(null)

  const handleItemClick = (item: string) => {
    const items = navItems?.find((i: any) => i.link?.label === item)

    if (items) {
      setActiveSubmenu(items)
    } else {
      // Handle navigation to specific page
      setIsOpen(false)
      setActiveSubmenu(null)
    }
  }

  const handleBack = () => {
    setActiveSubmenu(null)
  }

  return (
    <Sheet
      open={isOpen}
      onOpenChange={() => {
        if (isOpen) {
          setActiveSubmenu(null)
        }
        setIsOpen(!isOpen)
      }}
    >
      <SheetTitle></SheetTitle>
      <SheetTrigger asChild>
        <Button
          variant="default"
          size="icon"
          className="lg:hidden h-10 w-10 p-0 hover:bg-gray-800"
          aria-label="Open mobile menu"
        >
          <Menu className="h-6 w-6 text-white" />
        </Button>
      </SheetTrigger>

      <SheetContent
        side="right"
        className="w-[80%] lg:w-80 p-0 bg-[#222222]"
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        <div className="flex flex-col h-full">
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-gray-800">
            {activeSubmenu && (
              <Button
                variant="ghost"
                size="icon"
                onClick={handleBack}
                className="h-8 w-8 p-0 text-white hover:bg-gray-800"
              >
                <ChevronLeft className="h-5 w-5" />
              </Button>
            )}
          </div>

          <div className="flex-1 overflow-y-auto">
            {!activeSubmenu ? (
              // Main Menu
              <nav className="p-6">
                <ul className="space-y-1">
                  {navItems?.map((item: any) => (
                    <li key={item?.id}>
                      <button
                        onClick={() => handleItemClick(item?.link?.label)}
                        className={cn(
                          'w-full flex items-center justify-between p-4 text-left',
                          'text-white  rounded-md transition-colors',
                          'group ',
                        )}
                      >
                        <div>
                          <div className="font-medium text-lg">{item?.link?.label}</div>
                          {item?.description && (
                            <div className="text-sm text-gray-400 mt-0.5">{item?.description}</div>
                          )}
                        </div>
                        <ChevronRight className="h-5 w-5 text-gray-400 group-hover:text-white transition-colors" />
                      </button>
                    </li>
                  ))}
                </ul>
              </nav>
            ) : (
              <div className="p-6">
                <div className="mb-6">
                  <h2 className="text-xl font-semibold text-white mb-1">
                    {activeSubmenu?.link?.label}
                  </h2>
                  {activeSubmenu?.description && (
                    <p className="text-sm text-gray-400">{activeSubmenu?.description}</p>
                  )}
                </div>
                <nav>
                  <ul className="space-y-1">
                    {activeSubmenu?.subMenuItems?.map((subItem: any) => (
                      <li key={subItem?.id}>
                        <div
                          className={cn(
                            'w-full text-left p-3 text-white ',
                            'rounded-md transition-colors ',
                          )}
                        >
                          <div className="flex flex-row">
                            {' '}
                            <span className="hover:text-destructive cursor-pointer">
                              {subItem?.link?.label}
                            </span>
                            {subItem?.hasSubMenu && (
                              <ChevronRight
                                className="h-5 w-5 ml-auto"
                                // onClick={handleSubmenuToggle}
                              />
                            )}
                          </div>

                          {subItem?.hasSubMenu && (
                            <ul className="space-y-2 px-2">
                              {subItem?.subMenuItems?.map((item: any) => (
                                <li key={item?.id}>
                                  <div
                                    className={cn(
                                      'w-full text-left p-3 text-white hover:text-destructive cursor-pointer',
                                      'rounded-md transition-colors focus:outline-none focus:bg-gray-800',
                                    )}
                                  >
                                    {item?.link?.label}
                                  </div>
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
                      </li>
                    ))}
                  </ul>
                </nav>
              </div>
            )}
          </div>
        </div>
      </SheetContent>
    </Sheet>
  )
}
